import {Layout, Placeholder} from '~/components'
import _ from 'lodash'
import {useRef} from 'react'
import ApexChart from 'react-apexcharts'
import {useApexOptions} from './get_apex_options/index'
import './styles/index.less'
import {roundSeries} from '~/components/graph/helpers'

// ApexCharts goes bonkers when we try to set this with the layoutProp
const STYLE = {backgroundColor: 'white', overflowY: 'hidden'}

export const Graph = ({
	series = [],
	isLoading,
	popoutProps,
	formatX,
	formatY,
	horizontalLine,
	placeholderProps,
	apexOptions,
	width = 'full',
	height = 'full',
	graphName,
}) => {
	const layoutRef = useRef(null)
	const displayedSeries = isLoading ? series.map(currentSeries => ({...currentSeries, data: []})) : series

	const options = useApexOptions({
		layoutRef,
		popoutProps,
		horizontalLine,
		apexOptions,
		formatX,
		formatY,
		series: displayedSeries,
		graphName,
	})

	const noData = _.sumBy(_.flatMap(displayedSeries, 'data'), 'y') === 0
	const showPlaceholder = !isLoading && noData && placeholderProps

	const roundedSeries = roundSeries(displayedSeries)

	return (
		<Layout
			ref={layoutRef}
			className="graph"
			block
			grow
			width={width}
			height={height}
			minHeight={600}
			maxHeight={700}
			border
			borderRadius={8}
			padding={20}
			style={STYLE}
		>
			{!showPlaceholder && <ApexChart series={roundedSeries} options={options} type="line" width="100%" height="100%" />}
			{showPlaceholder && <Placeholder {...placeholderProps} />}
		</Layout>
	)
}
